import { applySpec, concat, equals, prop, propOr } from 'ramda';
import PropTypes from 'prop-types';
import { offerCodeEnum } from '@@viewEnums';
import React from 'react';
import { formatCurrency } from '@@viewHelpers/formatCurrency.mjs';
import { usePaymentCardOptions } from '../hooks/usePaymentCardOptions.js';
import { mapLabelValue } from '@@viewHelpers/string.js';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { Icon, Row } from '@fasstech/middle-design-system';

const PaymentCard = ({
  project,
  getMiddleText,
  middleFeatures,
  editSouscription3,
  offerCode,
  prevTnsCommission,
  isProjectEditable
}) => {
  const paymentOptions = usePaymentCardOptions(
    project,
    getMiddleText,
    middleFeatures
  );
  const { monthlyPrice, annualPrice, monthlyPriceMadelin, annualPriceMadelin } =
    applySpec({
      monthlyPrice: prop('monthlyPrice'),
      annualPrice: prop('annualPrice'),
      monthlyPriceMadelin: prop('monthlyPriceMadelin'),
      annualPriceMadelin: prop('annualPriceMadelin')
    })(project);

  const optionsCotisation = [
    {
      label: getMiddleText('COTISATION_MONTHLY_LABEL'),
      value: formatCurrency(monthlyPrice)
    },

    ...(equals(offerCode, offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION)
      ? [
        {
          label: getMiddleText('Déductible Madelin'),
          value: formatCurrency(monthlyPriceMadelin),
          bold: false
        }
      ]
      : []),

    {
      label: getMiddleText('COTISATION_ANNUAL_LABEL'),
      value: formatCurrency(annualPrice)
    },

    ...(equals(offerCode, offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION)
      ? [
        {
          label: getMiddleText('Déductible Madelin'),
          value: formatCurrency(annualPriceMadelin),
          bold: false
        },
        ...(prevTnsCommission
          ? [
            {
              label: getMiddleText(
                'NIVEAUXGARANTIESETTARIFS_TAUX_COMMISSION_TYPE_LABEL'
              ),
              value: propOr('', 'type', prevTnsCommission)
            },
            {
              label: getMiddleText(
                'NIVEAUXGARANTIESETTARIFS_TAUX_COMMISSION_LISTE_LABEL'
              ),
              value: propOr('', 'rate', prevTnsCommission)
            }
          ]
          : [])
      ]
      : [])
  ];

  return (
    <div className="border border-[#E7E7E7] rounded-md w-full">
      <div className={'w-full flex justify-between items-center p-4 border-b'}>
        <div className={'font-bold'}>
          {getMiddleText('RECAPITULATIF_COTISATION_INFORMATIONS_TITLE')}
        </div>
        {isProjectEditable && <Icon
          name={'circlePen'}
          size={30}
          className={'cursor-pointer'}
          onClick={editSouscription3}
        />}
      </div>
      <div className="flex flex-col gap-4 w-full p-4">
        {mapIndexed((item, index) => (
          <Row key={index} item={item} index={index} />
        ))(concat(optionsCotisation, mapLabelValue(paymentOptions)))}
      </div>
    </div>
  );
};

PaymentCard.propTypes = {
  project: PropTypes.object,
  getMiddleText: PropTypes.func,
  middleFeatures: PropTypes.object,
  editSouscription3: PropTypes.func,
  offerCode: PropTypes.string
};

export default PaymentCard;
